import dayjs from 'dayjs';
import path from 'path';
/**
 * @description 同步操作历史限制保存时间函数
 * @export
 * @return {*}  {number}
 */
export function getHistoryRecordLimitTimestamp(): number {
  return dayjs().subtract(10, 'days').valueOf();
}

/**
 * @description 每个 syncId 对应的同步历史操作记录允许的条目
 */
export const HISTORY_RECORD_LIMIT = 10000;

/**
 * @description 同步错误操作记录允许的条目
 */
export const ERROR_RECORD_LIMIT = 1000;

/**
 * @description 扫描等待队列间隔
 */
export const SCAN_WAITING_OPERATE_INTERVAL = 400;

/**
 * @description 本地文件夹全量扫描间隔
 */
export const FULL_SCAN_INTERVAL = 20 * 60 * 1000;

/**
 * @description 同步删除文件缓存路径
 */
export function getSyncDeleteCachePath(localSyncPath: string, localSyncId: number): string {
  const cacheName = `企业网盘同步缓存文件/${localSyncId}`;

  const rootFolder = path.dirname(localSyncPath);
  if (rootFolder === localSyncPath) {
    return '';
  }
  const cacheDir = path.join(rootFolder, cacheName);
  return cacheDir;
}
